import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Plus } from "lucide-react";

export function AddNode({ data }: NodeProps) {
  return (
    <div className="flex justify-center w-64">
      <Handle type="target" position={Position.Top} className="w-3 h-3 bg-primary opacity-0" />
      <button
        type="button"
        onClick={data.onAdd as () => void}
        className="size-10 rounded-full border-2 border-dashed border-input flex items-center justify-center text-muted-foreground/70 hover:border-primary hover:text-primary hover:bg-primary/5 bg-background"
      >
        <Plus size={20} />
      </button>
    </div>
  );
}
